/* unplugin-vue-components disabled */import { render } from "./DepartmentCostPane.vue?vue&type=template&id=b3edeb9a&scoped=true"
import script from "./DepartmentCostPane.vue?vue&type=script&lang=js"
export * from "./DepartmentCostPane.vue?vue&type=script&lang=js"

import "./DepartmentCostPane.vue?vue&type=style&index=0&id=b3edeb9a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3edeb9a"]])

export default __exports__